import React from 'react';
import StatusMessage from 'components/common/StatusMessage';

export const LoadingMessage = () => (
  <StatusMessage icon="fa-spinner fa-spin">Loading...</StatusMessage>
);
